import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Image, Link } from '@chakra-ui/react';
import { formatAssetsUrl, analytics } from '@whitbread-eos/utils';
import React, { useEffect } from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function PromotionBanner(_ref) {
  var data = _ref.data;
  var _ref2 = (data === null || data === void 0 ? void 0 : data.restaurant) || {},
    bookingCardImage = _ref2.bookingCardImage,
    bookingCardBackgroundImage = _ref2.bookingCardBackgroundImage;
  var _ref3 = (data === null || data === void 0 ? void 0 : data.bookRestaurantCta) || {},
    bookingCardCtaLink = _ref3.bookingCardCtaLink,
    bookingCardCtaText = _ref3.bookingCardCtaText;
  useEffect(() => {
    analytics.update({
      restaurantBanner: true
    });
  }, []);
  var handleClick = () => {
    window.__satelliteLoaded && window._satellite.track('restaurantBannerClicked');
  };
  return _jsxs(Box, _objectSpread(_objectSpread({}, styles.imageWrapper), {}, {
    bgImage: "url('".concat(formatAssetsUrl(bookingCardBackgroundImage !== null && bookingCardBackgroundImage !== void 0 ? bookingCardBackgroundImage : ''), "')"),
    children: [_jsx(Image, {
      src: formatAssetsUrl(bookingCardImage !== null && bookingCardImage !== void 0 ? bookingCardImage : ''),
      fit: "fill",
      w: "175px",
      m: "60px auto 0",
      "data-testid": 'promotion-banner-image'
    }), _jsx(Box, _objectSpread(_objectSpread({}, styles.buttonWrapper), {}, {
      children: _jsx(Link, _objectSpread(_objectSpread({}, styles.button), {}, {
        target: "_blank",
        "data-testid": 'promotion-banner-link',
        href: bookingCardCtaLink,
        fontSize: "18px",
        onClick: handleClick,
        children: bookingCardCtaText
      }))
    }))]
  }));
}
var styles = {
  imageWrapper: {
    float: 'left',
    position: 'relative',
    width: '100%',
    height: '214px',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundBlendMode: 'overlay'
  },
  buttonWrapper: {
    position: 'absolute',
    bottom: '15px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    padding: {
      mobile: '0 10px',
      xl: '0 23px'
    }
  },
  button: {
    height: '44px',
    width: {
      mobile: '260px',
      xs: '280px',
      sm: '260px',
      lg: '100%'
    },
    backgroundColor: 'var(--chakra-colors-baseWhite)',
    color: 'var(--chakra-colors-btnSecondaryEnabled)',
    fontWeight: '600',
    borderRadius: '4px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    _hover: {
      textDecoration: 'none',
      boxShadow: '0 4px 8px var(--chakra-colors-lightGrey2)',
      background: 'var(--chakra-colors-baseWhite) radial-gradient(circle, rgba(81, 30, 98, .15) 1%, var(--chakra-colors-baseWhite) 1%) center / 15000%'
    }
  }
};